import { doodBlockConfig, propertyValue } from "./dood-block-config";
import { cartPagePresetBlockBackgroundColorProperty } from "./cart-page-preset-block-background.util";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

/** Serializable preview VM for `ComoJoinLoyaltyBlockComponent`. */
export type ComoJoinLoyaltyBlockScenarioContent = {
  /** `null` shows the join checkbox. A user hides the block (already a member). */
  comoUser: {
    points_balance: {
      used_by_payment: boolean;
      monetary: number;
      non_monetary: number;
    };
    credit_balance: {
      used_by_payment: boolean;
      monetary: number;
      non_monetary: number;
    };
    assets: readonly [];
  } | null;
};

export const COMOJOINLOYALTYBLOCK_LEGACY_FIELD_ORDER = [];

const {
  comoJoinLoyaltyBlockDescriptor: _generatedComoJoinLoyaltyBlockDescriptor,
  comoJoinLoyaltyBlockBlocDefinition,
  comoJoinLoyaltyBlockDashboardLayout,
  comoJoinLoyaltyBlockConfig,
  comoJoinLoyaltyBlockResolveConfig,
  comoJoinLoyaltyBlockProperties,
  comoJoinLoyaltyBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Como - Join loyalty",
    componentType: "ComoJoinLoyaltyBlockComponent",
    category: "como",
    description: "Como - Join loyalty.",
    keywords: [],
    allowedIn: [{ bloc: "CartPageComponent", slot: "*" }],

    sharedFields: {},
  },

  () => ({
    background_color: cartPagePresetBlockBackgroundColorProperty(),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-page.fieldset.appearance.label",
            fields: ["background_color"],
          },
        ],
      },
    ],
  }),
);

export function comoJoinLoyaltyBlockDescriptor(): IBlockDescriptor;
export function comoJoinLoyaltyBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoJoinLoyaltyBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoJoinLoyaltyBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedComoJoinLoyaltyBlockDescriptor,
    comoJoinLoyaltyBlockProperties,
    fieldOrder,
  );
}

export {
  comoJoinLoyaltyBlockBlocDefinition,
  comoJoinLoyaltyBlockDashboardLayout,
  comoJoinLoyaltyBlockProperties,
  comoJoinLoyaltyBlockConfig,
  comoJoinLoyaltyBlockResolveConfig,
  comoJoinLoyaltyBlockDefinitionSetupScenarios,
};

export type ComoJoinLoyaltyBlockConfig = typeof comoJoinLoyaltyBlockConfig;
